var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-box"},[(_vm.edit_text !== 'empty')?_c('div',{staticClass:"btn",on:{"click":_vm.editHandler}},[_vm._v(_vm._s(_vm.edit_text))]):_vm._e(),_c('div',{staticClass:"btn",on:{"click":_vm.deleteHandler}},[_vm._v("删除")])])}
var staticRenderFns = []

export { render, staticRenderFns }